<template>
  <div class="home_container">
    <input type="file" @change="onFileChange" />
    <!-- <canvas ref="pdfCanvas"></canvas> -->
    <pdf
      v-if="pdfBytes"
      :src="pdfBytes"
      @progress="onProgress"
      @loaded="onLoaded"
      @error="onError"
      style="width: 100%; height: 100%"
    ></pdf>
  </div>
</template>

<script>
// import { getDocument, GlobalWorkerOptions } from "pdfjs-dist/build/pdf";
// import pdfjsWorker from "worker-loader!pdfjs-dist/build/pdf.worker.mjs";

// GlobalWorkerOptions.workerSrc = pdfjsWorker;
import pdf from "vue-pdf";
import axios from "axios";
// import { sm4 } from "gm-crypto";
import SM4 from "sm-crypto/src/sm4";

export default {
  components: {
    pdf,
  },
  data() {
    return {
      pdfDoc: null,
      currentPage: 1,
      password: "", // PDF 密码（如果有的话）
      decryptedBytes: null,
      pdfBytes: null,
      file: null,
      isLabcd: false,
      fileType: 0,
      startIndex: null,
      endIndex: null,
    };
  },
  mounted() {
    this.fetchPdf();
  },
  methods: {
    onProgress(progress) {
      console.log("Loading progress:", progress);
    },
    onLoaded(pdf) {
      console.log("PDF loaded:", pdf);
    },
    onError(error) {
      console.log("Error loading PDF:", error);
    },
    async fetchPdf() {
      try {
        const response = await axios.get("/api/hello.pdf", {
          responseType: "arraybuffer", // 确保响应是 ArrayBuffer 格式
        });
        // 获取文件内容
        const arrayBuffer = response.data;
        // 将 ArrayBuffer 转为 Uint8Array 以读取字节
        const bytes = new Uint8Array(arrayBuffer);
        // 判断每个字节是否等于 0xBB
        const allBB = Array.from(bytes.slice(0, 3)).every(
          (byte) => byte === 0xbb
        );
        // 设置结果信息
        this.isLabcd = allBB;
        if (this.isLabcd) {
          this.fileType = bytes[3];
          if (this.fileType > 0) {
            const startArray = Array.from(
              bytes.slice(
                5 + (this.fileType - 1) * 9,
                9 + (this.fileType - 1) * 9
              )
            );
            this.startIndex =
              (startArray[0] << 24) | // 第 5 字节（最高位）
              (startArray[1] << 16) | // 第 6 字节
              (startArray[2] << 8) | // 第 7 字节
              startArray[3];
            const endArray = Array.from(
              bytes.slice(
                9 + (this.fileType - 1) * 9,
                13 + (this.fileType - 1) * 9
              )
            );
            this.endIndex =
              (endArray[0] << 24) | // 第 5 字节（最高位）
              (endArray[1] << 16) | // 第 6 字节
              (endArray[2] << 8) | // 第 7 字节
              endArray[3];
            const decryptedBytes = bytes.slice(this.startIndex + this.endIndex);
            // console.log(decryptedBytes);
            this.decryptChunkedFile(
              decryptedBytes,
              "31B9772C59E9B0EC0000000000000000",
              "30313233343536373839616263646566"
            );
          }
        }
        // this.judgeFile(uint8Array);
        // const decryptedBytes = this.decryptBytes(uint8Array);
        // console.log(decryptedBytes);
        // this.decryptedBytes = decryptedBytes;
        // 现在你可以使用 uint8Array 进行其他处理，比如传递给 PDF.js 来显示 PDF
      } catch (error) {
        console.error("获取PDF文件失败", error);
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        // this.file = file
        console.log(file);
        this.judgeFile(file);
        // const fileReader = new FileReader();
        // fileReader.onload = (event) => {
        //   const encryptedBytes = new Uint8Array(event.target.result);
        //   const decryptedBytes = this.decryptBytes(encryptedBytes);
        //   //   console.log(decryptedBytes)
        //   this.decryptedBytes = decryptedBytes;
        //   //   this.loadPdf(decryptedBytes);
        // };
        // fileReader.readAsArrayBuffer(file);
      }
    },
    // 位数解密
    decryptBytes(encryptedBytes) {
      let decryptedBytes = new Uint8Array(encryptedBytes.length);
      for (let i = 0; i < encryptedBytes.length; i++) {
        decryptedBytes[i] = (encryptedBytes[i] - 98 + 256) % 256;
      }
      return decryptedBytes;
    },
    // 判断cd文件
    judgeFile(file) {
      if (file) {
        const reader = new FileReader();
        reader.onloadend = (e) => {
          // 获取文件内容
          const arrayBuffer = e.target.result;
          // 将 ArrayBuffer 转为 Uint8Array 以读取字节
          const bytes = new Uint8Array(arrayBuffer);
          // 判断每个字节是否等于 0xBB
          const allBB = Array.from(bytes.slice(0, 3)).every(
            (byte) => byte === 0xbb
          );
          // 设置结果信息
          this.isLabcd = allBB;
          if (this.isLabcd) {
            this.fileType = bytes[3];
            if (this.fileType > 0) {
              const startArray = Array.from(
                bytes.slice(
                  5 + (this.fileType - 1) * 9,
                  9 + (this.fileType - 1) * 9
                )
              );
              this.startIndex =
                (startArray[0] << 24) | // 第 5 字节（最高位）
                (startArray[1] << 16) | // 第 6 字节
                (startArray[2] << 8) | // 第 7 字节
                startArray[3];
              const endArray = Array.from(
                bytes.slice(
                  9 + (this.fileType - 1) * 9,
                  13 + (this.fileType - 1) * 9
                )
              );
              this.endIndex =
                (endArray[0] << 24) | // 第 5 字节（最高位）
                (endArray[1] << 16) | // 第 6 字节
                (endArray[2] << 8) | // 第 7 字节
                endArray[3];
              const decryptedBytes = bytes.slice(
                this.startIndex + this.endIndex
              );
              // console.log(decryptedBytes);
              this.decryptChunkedFile(
                decryptedBytes,
                "31B9772C59E9B0EC0000000000000000",
                "30313233343536373839616263646566"
              );
            }
          }
        };
        // 读取文件内容
        reader.readAsArrayBuffer(file);
      }
    },
    // sm4解密
    decryptChunkedFile(encryptedDataHex, keyHex, ivHex, chunkSize = 1024) {
      // const encryptedData = Buffer.from(encryptedDataHex, "hex");
      const encryptedData = encryptedDataHex;
      // console.log(encryptedData);
      const key = Buffer.from(keyHex, "hex");
      const iv = Buffer.from(ivHex, "hex");
      // let decryptedData = [];
      // 每次处理 chunkSize 字节
      this.decryptBytes = new Uint8Array([]);
      for (let offset = 0; offset < encryptedData.length; offset += chunkSize) {
        // 提取一块加密数据
        if (offset + chunkSize < encryptedData.length) {
          const chunk = encryptedData.slice(offset, offset + chunkSize);
          this.sm4OFBDecrypt(chunk, key, iv, false);
        } else {
          const chunk = encryptedData.slice(offset, offset + chunkSize);
          this.sm4OFBDecrypt(chunk, key, iv, true);
        }

        // console.log(chunk);
        // // 解密这块数据
        // const decryptedChunk = SM4.decrypt(chunk, key, {
        //   mode: "ecb",
        //   // iv: iv,
        //   padding: "none",
        //   inputEncoding: "array",
        //   keyEncoding: "hex",
        //   // outputEncoding: "array",
        //   output: "array",
        // });
        // console.log(decryptedChunk);
        // decryptedData = decryptedData.concat(decryptedChunk);
      }
      // console.log("解密后的数据:", decryptedData);
      // this.decryptBytes = decryptedData;
      // return decryptedData;
    },
    sm4OFBDecrypt(encryptedData, key, iv, type) {
      const blockSize = 16; // SM4 的块大小为 16 字节
      let output = new Uint8Array(encryptedData.length); // 用于存储解密后的数据
      let feedback = iv; // 初始化向量
      for (let i = 0; i < encryptedData.length; i += blockSize) {
        // 使用 SM4 ECB 模式加密 feedback 值
        let feedbackEncrypted = SM4.encrypt(feedback, key, {
          inputEncoding: "array",
          output: "array",
          padding: "none",
          mode: "ecb", // 使用 ECB 加密 feedback
        });

        // 将加密后的 feedback 与加密数据进行异或，生成明文
        for (let j = 0; j < blockSize && i + j < encryptedData.length; j++) {
          output[i + j] = encryptedData[i + j] ^ feedbackEncrypted[j];
        }
        // 更新 feedback 为上一次的 ECB 加密结果
        feedback = feedbackEncrypted;
      }
      // console.log(type)
      this.decryptBytes = this.mergeUint8Arrays([this.decryptBytes, output]);
      if (type) {
        this.pdfBytes = this.decryptBytes;
      }
      return output;
    },
    mergeUint8Arrays(arrays) {
      // 计算合并后的总长度
      const totalLength = arrays.reduce((sum, arr) => sum + arr.length, 0);
      // 创建一个新的 Uint8Array，长度为所有数组长度的总和
      const mergedArray = new Uint8Array(totalLength);

      // 逐个数组进行合并
      let offset = 0;
      arrays.forEach((arr) => {
        mergedArray.set(arr, offset); // 将当前数组的内容复制到 mergedArray 中
        offset += arr.length; // 更新偏移量
      });

      return mergedArray;
    },
    // async loadPdf(decryptedBytes) {
    //   try {
    //     this.pdfDoc = await getDocument({ data: decryptedBytes }).promise;
    //     this.renderPage(this.currentPage);
    //   } catch (error) {
    //     // console.log('加载解密后的PDF文件失败:', error.message);
    //   }
    // },
    // async renderPage(pageNumber) {
    //   const page = await this.pdfDoc.getPage(pageNumber);
    //   const viewport = page.getViewport({ scale: 1.5 });
    //   const canvas = this.$refs.pdfCanvas;
    //   const context = canvas.getContext("2d");
    //   canvas.height = viewport.height;
    //   canvas.width = viewport.width;

    //   const renderContext = {
    //     canvasContext: context,
    //     viewport: viewport,
    //   };

    //   page.render(renderContext);
    // },
    // async  customGetDocumentWithFetch(url) {
    //     try {
    //         const response = await fetch(url);
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }
    //         // 获取加密的二进制数据
    //         let encryptedData = await response.arrayBuffer();
    //         // 打印原始的 ArrayBuffer
    //         console.log("Original encryptedData (ArrayBuffer):", encryptedData);
    //         // 将 ArrayBuffer 转换为 Uint8Array 并打印
    //         let uint8View = new Uint8Array(encryptedData);
    //         console.log("Encrypted data as Uint8Array:", uint8View);
    //         // 如果想查看十六进制格式，可以将 Uint8Array 转换为 Hex 字符串
    //         let hexString = Array.from(uint8View)
    //                               .map(b => b.toString(16).padStart(2, '0'))
    //                               .join(' ');
    //         console.log("Encrypted data in Hex format:", hexString);
    //         // 这里进行解密操作
    //         const decryptedData = await decryptPdfData(encryptedData);
    //         // 将解密后的二进制数据传递给 PDF.js 进行处理
    //         return pdfjsLib.getDocument({ data: decryptedData }).promise;
    //     } catch (error) {
    //         console.error('Error fetching or decrypting PDF:', error);
    //     }
    // },
    // // 示例解密函数（使用AES-GCM进行解密）
    // async decryptPdfData(encryptedData) {
    //     // 加密密钥 (应在实际应用中安全地存储和管理密钥)
    //     const key = await crypto.subtle.importKey(
    //         "raw",
    //         new TextEncoder().encode("your-32-byte-encryption-key"), // 32字节密钥
    //         "AES-GCM",
    //         false,
    //         ["decrypt"]
    //     );
    //     // 初始化向量 (IV)，确保与你加密时使用的IV相同
    //     const iv = new Uint8Array(12); // 12字节IV
    //     // 解密数据
    //     const decryptedData = await crypto.subtle.decrypt(
    //         { name: "AES-GCM", iv: iv },
    //         key,
    //         encryptedData
    //     );
    //     return decryptedData;
    // },
    // // 使用自定义的getDocument函数
    // customGetDocumentWithFetch('encrypted-pdf.pdf')
    //     .then(pdf => {
    //         // 加载并渲染第一页
    //         pdf.getPage(1).then(page => {
    //             const scale = 1.5;
    //             const viewport = page.getViewport({ scale: scale });
    //             const canvas = document.getElementById('pdf-canvas');
    //             const context = canvas.getContext('2d');
    //             canvas.height = viewport.height;
    //             canvas.width = viewport.width;
    //             const renderContext = {
    //                 canvasContext: context,
    //                 viewport: viewport
    //             };
    //             page.render(renderContext);
    //         });
    //     })
    //     .catch(error => {
    //         console.error('Error loading PDF:', error);
    //     });
  },
};
</script>

<style lang="scss" scoped></style>
